import { CourseForm } from './CourseForm';
export default CourseForm;